import { AuthLayout } from '@/components/auth-layout';
import { PROVIDER_NAMES } from '../constants';
import { useSignInFlow } from '../hooks/use-sign-in-flow';
import { EmailSentView } from './email-sent-view';
import { LinkExpiredView } from './link-expired-view';
import { OAuthFailedView } from './oauth-failed-view';
import { OAuthWaitingView } from './oauth-waiting-view';
import { SignInFormView } from './sign-in-form-view';

/** Sign in and sign up in one: Google, GitHub or an email link (design: Auth). */
export function SignInPanel() {
  const { view, viewKey, showForm, showSent, startOAuth, cancelOAuth } = useSignInFlow();

  return (
    <AuthLayout viewKey={viewKey}>
      {view.name === 'form' ? (
        <SignInFormView onOAuth={startOAuth} onSent={(link) => showSent(link, false)} />
      ) : null}
      {view.name === 'oauth' ? (
        <OAuthWaitingView providerName={PROVIDER_NAMES[view.provider]} onCancel={cancelOAuth} />
      ) : null}
      {view.name === 'oauth-error' ? (
        <OAuthFailedView
          provider={view.provider}
          providerName={PROVIDER_NAMES[view.provider]}
          onRetry={startOAuth}
          onUseEmail={showForm}
        />
      ) : null}
      {view.name === 'sent' ? (
        <EmailSentView
          link={view.link}
          isResent={view.isResent}
          onResent={(link) => showSent(link, true)}
          onUseDifferentEmail={showForm}
        />
      ) : null}
      {view.name === 'expired' ? (
        <LinkExpiredView link={view.link} onSent={(link) => showSent(link, false)} />
      ) : null}
    </AuthLayout>
  );
}
